export const websiteThemes = [
  {
    name: 'Light',
    palettes: ['#FFFFFF', '#4A00FF', '#FF00D3', '#00D7C0', '#2B3440'],
  },
  {
    name: 'Dark',
    palettes: ['#1D232A', '#7480FF', '#FF52D9', '#00CDB7', '#2A323C'],
  },
  {
    name: 'Cupcake',
    palettes: ['#FAF7F5', '#65C3C8', '#EF9FBC', '#EEAF3A', '#291334'],
  },
  {
    name: 'Bumblebee',
    palettes: ['#FFFFFF', '#FFD900', '#FFA400', '#FFA451', '#060023'],
  },
  {
    name: 'Emerald',
    palettes: ['#FFFFFF', '#66CC8A', '#377CFB', '#F68067', '#333C4D'],
  },
  {
    name: 'Corporate',
    palettes: ['#FFFFFF', '#4D6EFF', '#7B92B2', '#67CBA0', '#181A2A'],
  },
  {
    name: 'Synthwave',
    palettes: ['#1A103D', '#E779C1', '#58C7F3', '#FFD200', '#221551'],
  },
  {
    name: 'Retro',
    palettes: ['#ECE3CA', '#EF9995', '#A4CBB4', '#DC8850', '#2E282A'],
  },
  {
    name: 'Cyberpunk',
    palettes: ['#FFF248', '#FF6596', '#00E8FF', '#CE74FF', '#111A3B'],
  },
  {
    name: 'Valentine',
    palettes: ['#FAE7F4', '#E96D7B', '#A991F7', '#66B1B3', '#AF4670'],
  },
  {
    name: 'Halloween',
    palettes: ['#212121', '#FF8F00', '#7A00C2', '#42AA00', '#2F1B05'],
  },
  {
    name: 'Garden',
    palettes: ['#E9E7E7', '#E9E7E7', '#8E4162', '#5C7F67', '#291E00'],
  },
  {
    name: 'Forest',
    palettes: ['#171212', '#1EB854', '#1DB88E', '#1DB8AB', '#19362D'],
  },
  {
    name: 'Aqua',
    palettes: ['#345DA7', '#08ECF3', '#966FB3', '#FFE999', '#3B8AC4'],
  },
  {
    name: 'Iofi',
    palettes: ['#FFFFFF', '#0D0D0D', '#1A1919', '#262626', '#000000'],
  },
  {
    name: 'Pastel',
    palettes: ['#FFFFFF', '#D1C1D7', '#F6CBD1', '#B4E9D6', '#70ACC7'],
  },
  {
    name: 'Fantasy',
    palettes: ['#FFFFFF', '#6D0076', '#0075C2', '#FF8600', '#1F2937'],
  },
  {
    name: 'Wireframe',
    palettes: ['#FFFFFF', '#B8B8B8', '#B8B8B8', '#B8B8B8', '#EBEBEB'],
  },
  {
    name: 'Black',
    palettes: ['#000000', '#373737', '#373737', '#373737', '#373737'],
  },
  {
    name: 'Luxury',
    palettes: ['#09090B', '#FFFFFF', '#152747', '#513448', '#331800'],
  },
  {
    name: 'Dracula',
    palettes: ['#282A36', '#FF79C6', '#BD93F9', '#FFB86C', '#414558'],
  },
  {
    name: 'Cmyk',
    palettes: ['#FFFFFF', '#45AEEE', '#E8488A', '#FFF232', '#1A1A1A'],
  },
  {
    name: 'Autumn',
    palettes: ['#F1F1F1', '#8C0327', '#D85251', '#D59B6A', '#826A5C'],
  },
  {
    name: 'Business',
    palettes: ['#202020', '#1C4E80', '#7C909A', '#EA6947', '#23282E'],
  },
  {
    name: 'Acid',
    palettes: ['#FAFAFA', '#FF00FF', '#FF6E00', '#C7FF00', '#140151'],
  },
  {
    name: 'Lemonade',
    palettes: ['#F8FDEF', '#419400', '#BDC000', '#EDD000', '#343300'],
  },
  {
    name: 'Night',
    palettes: ['#0F172A', '#38BDF8', '#818CF8', '#F471B5', '#1E293B'],
  },
  {
    name: 'Coffee',
    palettes: ['#20161F', '#DB924B', '#263E3F', '#10576D', '#120C12'],
  },
  {
    name: 'Winter',
    palettes: ['#FFFFFF', '#0069FF', '#463AA2', '#C148AC', '#021431'],
  },
  {
    name: 'Dim',
    palettes: ['#2A303C', '#9FE88D', '#FF7D5C', '#C792E9', '#1C212B'],
  },
  {
    name: 'Nord',
    palettes: ['#ECEFF4', '#5E81AC', '#81A1C1', '#88C0D0', '#4C566A'],
  },
  {
    name: 'Sunset',
    palettes: ['#121C22', '#FF865B', '#FD6F9C', '#B387FA', '#1B262C'],
  },
];

export const optionsSelectTheme = [
  {
    value: '',
    text: 'Choose website themes',
  },
  {
    value: 'light',
    text: 'Light',
    palettes: ['#FFFFFF', '#4A00FF', '#FF00D3', '#00D7C0', '#2B3440'],
  },
  {
    value: 'dark',
    text: 'Dark',
    palettes: ['#1D232A', '#7480FF', '#FF52D9', '#00CDB7', '#2A323C'],
  },
  {
    value: 'cupcake',
    text: 'Cupcake',
    palettes: ['#FAF7F5', '#65C3C8', '#EF9FBC', '#EEAF3A', '#291334'],
  },
  {
    value: 'bumblebee',
    text: 'Bumblebee',
    palettes: ['#FFFFFF', '#FFD900', '#FFA400', '#FFA451', '#060023'],
  },
  {
    value: 'emerald',
    text: 'Emerald',
    palettes: ['#FFFFFF', '#66CC8A', '#377CFB', '#F68067', '#333C4D'],
  },
  {
    value: 'corporate',
    text: 'Corporate',
    palettes: ['#FFFFFF', '#4D6EFF', '#7B92B2', '#67CBA0', '#181A2A'],
  },
  {
    value: 'synthwave',
    text: 'Synthwave',
    palettes: ['#1A103D', '#E779C1', '#58C7F3', '#FFD200', '#221551'],
  },
  {
    value: 'retro',
    text: 'Retro',
    palettes: ['#ECE3CA', '#EF9995', '#A4CBB4', '#DC8850', '#2E282A'],
  },
  {
    value: 'cyberpunk',
    text: 'Cyberpunk',
    palettes: ['#FFF248', '#FF6596', '#00E8FF', '#CE74FF', '#111A3B'],
  },
  {
    value: 'valentine',
    text: 'Valentine',
    palettes: ['#FAE7F4', '#E96D7B', '#A991F7', '#66B1B3', '#AF4670'],
  },
  {
    value: 'halloween',
    text: 'Halloween',
    palettes: ['#212121', '#FF8F00', '#7A00C2', '#42AA00', '#2F1B05'],
  },
  {
    value: 'garden',
    text: 'Garden',
    palettes: ['#E9E7E7', '#E9E7E7', '#8E4162', '#5C7F67', '#291E00'],
  },
  {
    value: 'forest',
    text: 'Forest',
    palettes: ['#171212', '#1EB854', '#1DB88E', '#1DB8AB', '#19362D'],
  },
  {
    value: 'aqua',
    text: 'Aqua',
    palettes: ['#345DA7', '#08ECF3', '#966FB3', '#FFE999', '#3B8AC4'],
  },
  {
    value: 'iofi',
    text: 'Iofi',
    palettes: ['#FFFFFF', '#0D0D0D', '#1A1919', '#262626', '#000000'],
  },
  {
    value: 'pastel',
    text: 'Pastel',
    palettes: ['#FFFFFF', '#D1C1D7', '#F6CBD1', '#B4E9D6', '#70ACC7'],
  },
  {
    value: 'fantasy',
    text: 'Fantasy',
    palettes: ['#FFFFFF', '#6D0076', '#0075C2', '#FF8600', '#1F2937'],
  },
  {
    value: 'wireframe',
    text: 'Wireframe',
    palettes: ['#FFFFFF', '#B8B8B8', '#B8B8B8', '#B8B8B8', '#EBEBEB'],
  },
  {
    value: 'black',
    text: 'Black',
    palettes: ['#000000', '#373737', '#373737', '#373737', '#373737'],
  },
  {
    value: 'luxury',
    text: 'Luxury',
    palettes: ['#09090B', '#FFFFFF', '#152747', '#513448', '#331800'],
  },
  {
    value: 'dracula',
    text: 'Dracula',
    palettes: ['#282A36', '#FF79C6', '#BD93F9', '#FFB86C', '#414558'],
  },
  {
    value: 'cmyk',
    text: 'Cmyk',
    palettes: ['#FFFFFF', '#45AEEE', '#E8488A', '#FFF232', '#1A1A1A'],
  },
  {
    value: 'autumn',
    text: 'Autumn',
    palettes: ['#F1F1F1', '#8C0327', '#D85251', '#D59B6A', '#826A5C'],
  },
  {
    value: 'business',
    text: 'Business',
    palettes: ['#202020', '#1C4E80', '#7C909A', '#EA6947', '#23282E'],
  },
  {
    value: 'acid',
    text: 'Acid',
    palettes: ['#FAFAFA', '#FF00FF', '#FF6E00', '#C7FF00', '#140151'],
  },
  {
    value: 'lemonade',
    text: 'Lemonade',
    palettes: ['#F8FDEF', '#419400', '#BDC000', '#EDD000', '#343300'],
  },
  {
    value: 'night',
    text: 'Night',
    palettes: ['#0F172A', '#38BDF8', '#818CF8', '#F471B5', '#1E293B'],
  },
  {
    value: 'coffee',
    text: 'Coffee',
    palettes: ['#20161F', '#DB924B', '#263E3F', '#10576D', '#120C12'],
  },
  {
    value: 'winter',
    text: 'Winter',
    palettes: ['#FFFFFF', '#0069FF', '#463AA2', '#C148AC', '#021431'],
  },
  {
    value: 'dim',
    text: 'Dim',
    palettes: ['#2A303C', '#9FE88D', '#FF7D5C', '#C792E9', '#1C212B'],
  },
  {
    value: 'nord',
    text: 'Nord',
    palettes: ['#ECEFF4', '#5E81AC', '#81A1C1', '#88C0D0', '#4C566A'],
  },
  {
    value: 'sunset',
    text: 'Sunset',
    palettes: ['#121C22', '#FF865B', '#FD6F9C', '#B387FA', '#1B262C'],
  },
];
